import { company } from '~/company/Company';

import type { AnalyticsProvider } from '../types';

export class YandexMetrikaProvider implements AnalyticsProvider {
  readonly name = 'yandexMetrika' as const;
  readonly requiresConsent = true;

  private get token(): number | undefined {
    return company.config.apis?.yaMetrika?.token as number | undefined;
  }

  isAvailable(): boolean {
    return typeof window !== 'undefined' && !!this.token;
  }

  initialize(): void {
    // Yandex Metrika is loaded via server-injected script, no initialization needed
  }

  track(eventName: string, payload: Record<string, unknown>): void {
    if (!window.ym || !this.token) return;
    window.ym(this.token, 'reachGoal', eventName, payload);
  }
}
